// frontend/src/pages/affiliateProgram/AffiliateProgram.jsx

import React, { useState } from "react";
import "./affiliateProgram.css";
import { Link } from "react-router-dom";

export default function AffiliateProgram() {
  const [selectedType, setSelectedType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      organization: form.organization.value,
      message: form.message.value,
      type: form.type.value,
      otherTypeDetail:
        form.type.value === "other" ? form.otherTypeDetail.value.trim() : "",
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_API}affiliateProgram`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        window.location.href = "/affiliate-program-thank-you";
      } else {
        const err = await res.json();
        alert(`Error: ${err.message || "Something went wrong."}`);
      }
    } catch (err) {
      console.error(err);
      alert("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="affiliate-program-container">
      <section className="affiliate-program-hero">
        <h1>Affiliate Program</h1>
        <p>
          We champion writers—and we’re inviting creators and publishers to join our Affiliate Program. Share FLOW with your audience and earn <strong>$35-45 for every paid annual signup</strong> — no inventory, no overhead.
        </p>

        <p style={{ marginTop: "15px" }}>
          If you’re a retailer, nonprofit or educational institution looking for a partnership opportunity, apply here:{" "}
          <Link to="/partnerships">Partnerships</Link>.
        </p>

      </section>
      <section className="affiliate-program-section">
        <h2>Our Affiliate Model</h2>

        <p>
          Our Affiliate Program is simple: share your unique promo code with your audience and earn a commission for every new paid annual subscriber.
        </p>
        <div style={{ marginTop: "10px" }}>
          <div><strong>Commission Tiers</strong> (per paid annual signup):</div>
          <ul
            style={{
              marginTop: "8px",
              marginBottom: "6px",
              paddingLeft: 0,
              listStylePosition: "inside",
            }}
          >
            <li>1–9 paid signups: <strong>$35</strong></li>
            <li>10–24 paid signups: <strong>$40</strong></li>
            <li>25+ paid signups: <strong>$45</strong></li>
          </ul>
        </div>

      </section>
      <section className="affiliate-program-section">
        <h2>How It Works</h2>
        <ol>
          <li><strong>Receive a Unique Promo Code</strong> – Your audience gets $20 off our Annual Plan (regularly $90/year).</li>
          <li><strong>Share with Your Audience</strong> – Post it anywhere you connect with your community: social media, newsletters, blogs, resource pages, or emails.</li>
          <li><strong>Earn $35-45 Per Referral</strong> – For every new annual subscriber who uses your code.</li>
        </ol>

      </section>
      <section className="affiliate-program-section">
        <h2>Why It Works</h2>
        <ul>
          <li><strong>Earn $35-45</strong> per annual subscriber you refer—<strong>no limit</strong>.</li>
          <li>Offer your audience an <strong>exclusive $20 discount</strong> on our annual subscription.</li>
          <li><strong>Start earning in minutes.</strong> No setup, no stock, no risk—just share your unique code.</li>
          <li><strong>Align your brand</strong> with a mission-driven platform supporting talented emerging writers.</li>
        </ul>

      </section>
      <section className="affiliate-program-section">
        <h2>Who This Is For</h2>
        <ul>
          <li><strong>Influencers & creators</strong> – YouTube, TikTok, LinkedIn, Instagram, Facebook, podcasts, etc.</li>
          <li><strong>Bloggers & SEO sites</strong> – Reviews, writing resources, reading lists, etc.</li>
          <li><strong>Newsletter publishers</strong> – Substack, email lists, etc.</li>
          <li><strong>Communities</strong> – Discords, forums, writing groups, etc.</li>
        </ul>

      </section>
      <section className="affiliate-program-section">
        <h2>Apply to the Affiliate Program</h2>
        <p style={{ marginBottom: "15px" }}>
          Fill out the form below to request your promo code. If approved, you’ll receive a unique code to share with your audience.
        </p>

        <form className="affiliate-program-form" onSubmit={handleSubmit} autoComplete="off">
          <label>
            Name*
            <input type="text" name="name" required />
          </label>
          <label>
            Email*
            <input type="email" name="email" required />
          </label>
          <label>
            Organization (optional)
            <input type="text" name="organization" />
          </label>
          <label>
            Affiliate Type*
            <select
              name="type"
              defaultValue=""
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              required
            >
              <option value="" disabled hidden>Select one...</option>
              <option value="influencer">Influencers & Creator — YouTube, TikTok, Instagram, podcasts</option>
              <option value="blogger">Bloggers & SEO Sites — Reviews, writing resources, reading lists</option>
              <option value="newsletter">Newsletter Publishers — Substack, email lists</option>
              <option value="community">Communities — Discords, forums, writing groups</option>
              <option value="other">Other</option>
            </select>
          </label>
          {selectedType === "other" && (
            <label>
              Please describe your affiliate channel<span aria-hidden="true">*</span>
              <input type="text" name="otherTypeDetail" required minLength={3} />
            </label>
          )}
          <label>
            Where will you share your promo code (links, platforms, or newsletter)?*
            <textarea name="message" rows="5" required />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Request Promo Code"}
          </button>
        </form>
      </section>

      <div className="back-link">
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}
